import { useState, useCallback } from 'react'
import { Link, useNavigate, useLocation } from 'react-router'
import logo from '#app/assets/images/logos/logo-navbar.svg'
import { NavBar, type NavTab } from '../ui/navbar'

export default function AppNavbar() {
	const navigate = useNavigate()
	const location = useLocation()
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

	// Determinar el tab activo basado en la ruta actual
	const getActiveTab = () => {
		const path = location.pathname
		if (path === '/') return 'home'
		if (path.startsWith('/seguros')) return 'seguros'
		if (path.startsWith('/proposito')) return 'proposito'
		if (path.startsWith('/technology')) return 'technology'
		return 'home'
	}

	// Funciones para el menú mobile
	const handleMobileMenuToggle = useCallback(() => {
		setIsMobileMenuOpen((prev) => !prev)
	}, [])

	const handleMobileMenuClose = useCallback(() => {
		setIsMobileMenuOpen(false)
	}, [])

	const navTabs: NavTab[] = [
		{
			id: 'home',
			label: 'Inicio',
			isActive: getActiveTab() === 'home',
			href: '/',
		},
		{
			id: 'seguros',
			label: 'Seguros',
			isActive: getActiveTab() === 'seguros',
			href: '/seguros',
		},
		{
			id: 'proposito',
			label: 'Propósito',
			isActive: getActiveTab() === 'proposito',
			href: '/proposito',
		},
		{
			id: 'technology',
			label: 'Technology',
			isActive: getActiveTab() === 'technology',
			href: '/technology',
		},
	]

	return (
		<NavBar
			logo={
				<Link to="/">
					<img
						src={logo}
						alt="100prevalor logo"
						className="h-[34px] w-[179px] object-contain"
					/>
				</Link>
			}
			tabs={navTabs}
			onTabClick={(tabId) => {
				const href = tabId === 'home' ? '/' : `/${tabId}`
				void navigate(href)
			}}
			button={{
				label: 'Cotizar mi seguro',
				variant: 'secondary',
				appearance: 'solid',
				onClick: () => void navigate('/seguros'),
			}}
			mobileMenu={{
				isOpen: isMobileMenuOpen,
				onToggle: handleMobileMenuToggle,
				onClose: handleMobileMenuClose,
			}}
		/>
	)
}
